<template lang="pug">
	.widget-container(v-if="ready" :id="randomId" v-observe-visibility="triggerHeight")
		.blue-bar(v-if="!showResults")
		.select-state-container(v-if="!showResults")
			h2 Find a 529 Plan. Select your state below.
			p Did you know that residents are not limited to investing in their own state’s plan? Another state may offer a plan that performs better and has lower fees. Select your state below to see your state’s plan and other options.
			.map
				sfc-us-map(:states-list="stateOptions" @clicked="mapClicked($event)")
			.state-select
				sfc-select(v-model="selectedState" :options="stateOptions")
				a.btn.sfc-blue.sfc-button(@click="enableResults()")
					| CONTINUE
		.results-container(v-if="showResults")
			// Copy goes here
			.change-state(@click="showResults = false; sendHeight()")
				a Change state
				a.not-in(@click="showResults = false; sendHeight()") Not in {{selectedState.label}}?
			sfc-selected-state-copy(:state="selectedState" :plan="selectedState.consumer_plans[0]")
			//- h2 You have great Options
			//- p Tempor tempor labore velit in officia mollit adipisicing magna. Velit fugiat culpa Lorem laborum ad fugiat veniam nisi elit eiusmod. Aute dolore id nulla consequat voluptate culpa anim laboris mollit in commodo esse. Qui nostrud aliquip quis pariatur sit do.
			.tabs
				.tab(v-if="statePlans.length > 0" :class="{'active': activeTab == 0}" @click="activeTab = 0; sendHeight()")  Your state's plan
				.tab(:class="{'active': activeTab == 1}" @click="activeTab = 1; sendHeight()")  Highly Rated
				.tab(:class="{'active': activeTab == 2}" @click="activeTab = 2; sendHeight()")  Lowest Fees

			.tab-content(v-show="activeTab == 0" v-if="statePlans.length > 0")
				sfc-plan-card.plan-card(v-for="plan of statePlans" click-source="Plan Selection Wizard" :is-red-button="true" :plan="plan" page="Plan Selection Wizard" :state="selectedState")
			.tab-content(v-show="activeTab == 1")
				sfc-plan-card(click-source="Plan Selection Wizard" :is-red-button="true" :plan="highlyRatedPlan" page="Plan Selection Wizard" :state="selectedState")
			.tab-content(v-show="activeTab == 2")
				sfc-plan-card.plan-card(v-for="plan of selectedState.savings_center_lowest_fees" click-source="Plan Selection Wizard" :is-red-button="true" :plan="plan" page="Plan Selection Wizard" :state="selectedState")



</template>

<style lang="stylus">
@import "./assets/css/general.styl"
</style>

<style lang="stylus" scoped>
@import "./assets/css/variables.styl"
.widget-container
	background-color: bg-gray
	border: 1px solid sfc-pale-gray
	box-shadow()
	padding: 30px 30px 0 30px
	overflow: hidden
	max-width: 800px
	margin: auto
	position: relative
	padding-top: 50px


	h2
		font-size: 18px
		line-height: body-font-line-height-sm
	p
		font-size: body-font-size
		line-height: body-font-line-height

	.blue-bar
		height: 5px
		background: #1ca8fc
		border: 1px solid #255ef7
		position: absolute
		top: 0
		width: 100%
		left: 0

	.map
		padding-bottom: 30px
		@media (max-width: 610px)
			display: none

	.select-state-container
		.state-select
			display: none
			margin-top: 30px
			margin-bottom: 30px
			@media (max-width: 610px)
				display: block
			.sfc-button
				margin-top: 30px
				width: 100%

	.results-container
		.change-state
			margin-bottom: 30px
			a
				color: #000
				cursor: pointer
				@media(max-width: 610px)
					display: none
				&.not-in
					display: none
					color: sfc-royal-blue
					@media(max-width: 610px)
						display: block

		.tabs
			margin: 40px -31px 0 -31px
			// margin: 50px -31px 50px -31px
			display: flex
			.tab
				flex-basis: 33.33%
				flex-grow: 1
				text-align: center
				cursor: pointer
				padding: 20px 0
				position: relative
				border-right: 1px solid sfc-pale-gray
				border-bottom: 1px solid sfc-pale-gray
				border-top: 1px solid sfc-pale-gray
				&:last-child
					border-right: 0
				&.active
					border-bottom: 1px solid transparent
					background-color: #fff
					&:before
						box-sizing: border-box
						position: absolute
						top: 0
						left: 0
						width: 100%
						content: ''
						height: 5px
						background-color: sfc-royal-blue-bright
						border: 1px solid sfc-royal-blue-dark
						margin-top: -1px
		.tab-content
			background: #fff
			margin: 0 -31px
			padding: 30px
			.plan-card
				margin-top: 60px
				&:first-child
					margin-top: 0

</style>

<script>

import axios from 'axios'
import {queryParams} from './query_params'
import {trackAnalyticsAction} from './track'
import SfcSelect from './components/select'
import SfcUsMap from './components/sfc-us-map'
import SfcPlanCard from './components/sfc-plan-card-a'
import SfcSelectedStateCopy from './components/sfc-selected-state-copy-v2'
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

export default {
	components: {
		SfcSelect,
		SfcUsMap,
		SfcPlanCard,
		SfcSelectedStateCopy
	},
	data () {
		return{
			ready: false,
			states: [],
			bestPerformingPlan: {},
			highlyRatedPlan: {},
			vanguardPlan: {},
			params: {},
			activeTab: 0,
			clickSource: undefined,
			selectedState: {},
			showResults: false,
			widgetIdentifier: "",
			randomId: "theId"
		}
	},
	computed: {
		stateOptions () {
			if (this.states.length == 0) {
				return []
			}

			return this.states.map( (state) => {
				state.label = state.name
				return state
			})
		}
	},

	methods: {
		triggerHeight(isVisible, entry){
			if(isVisible){
				this.sendHeight()
			}
		},
		mapClicked (id) {
			this.selectedState = this.stateOptions.filter( state => state.id == id )[0]
			this.enableResults()
		},
		enableResults() {
			this.statePlans = this.selectedState.consumer_plans
			this.activeTab = 0
			if(this.statePlans.length == 0){
				this.activeTab = 1
			}
			this.showResults = true
			this.sendHeight()
		},
		async getData(){
			let url = process.env.DATA_URL
			let response
			try{
				response = await axios.get(url)
				const decodedResponse = this.decode(response.data)
				this.states = decodedResponse.data.states
				this.selectedState = this.states[0]
				this.selectedState.label = this.selectedState.name
				this.bestPerformingPlan = decodedResponse.data.best_performing_plan
				this.highlyRatedPlan = decodedResponse.data.highly_rated_plan
				this.vanguardPlan = decodedResponse.data.vanguard_plan
			} catch (e) {
				return
			}
			try {
				const query = `
					query{
						no_graphql_cache()
						state_from_ip(){
							id
							sfc_id
							name
							slug
						}
					}
				`
				let responseState
				response = await axios.post(`${process.env.SFC_URL}/graphql`, { query }).then( response => {
					responseState = response.data.data.state_from_ip
				})

				this.selectedState = this.states.filter( state => state.id == responseState.id )[0]
				this.selectedState.label = this.selectedState.name

			} catch (e) {
				return
			}
			this.ready = true
			this.sendHeight()
			this.$nextTick(function() {
				window.addEventListener("resize", this.sendHeight())
			})
		},

		b64DecodeUnicode(input) {
			input = input.replace(/\s/g, '');
  			return atob(input);
		},

		decode(data, cyphered = true){

			let response = {}
			let decoded

			if (cyphered) {
				decoded = this.b64DecodeUnicode(data)
				decoded = JSON.parse(decoded.substring(3,decoded.length-1))
			}
			else{
				decoded = data
			}
			return decoded
		},

		sendHeight(left = 5) {
			let appDiv = document.getElementById(this.randomId)
			if (appDiv) {
				window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 5}, "*")
				setTimeout(() => {
					window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 5}, "*")
					if (left > 0) {
						this.sendHeight(left - 1)
					}
				}, 200)
			} else {
				setTimeout (() => {
					this.sendHeight()
				}, 100)
			}
		}
	},

	mounted(){
		this.params = queryParams()
		this.clickSource = this.params.clickSource || "article"
		this.widgetIdentifier = this.params.widgetIdentifier
		this.getData()
		let randomNumber = Math.ceil(Math.random()*1000000)
		this.randomId = `sfc-external-ad-container-${randomNumber}`
	}

}
</script>

